export const appName = "Real-time Analytical Monitoring of PV assets";

export const markRequired = value => (value + " *");

export const lblDashboard = "Dashboard";
export const lblDashboardSocialMedia = "SERIS Social Platform";
export const lblDashboardStationInfo = "Station Info and Health Status";
export const lblDashboardStationMap = "Station Location Map";
export const lblDashboardStatisticsWeather = "Station Statistics  & Weather Information";
export const lblUsers = "Users";
export const lblUsersList = "Users List Table";
export const lblUserInformation = "User information";
export const lblStations = "Stations";
export const lblStationsList = "Stations List Table";
export const lblPersonas = "Personas";
export const lblStationConfigs = "Station configurations"
export const lblLogout = "Log out";
export const lblCancel = "Cancel";
export const lblReset = "Reset";
export const lblReport = "Report";
export const lblSentReports = "Sent reports";
export const lblResetPassword = `${lblReset} password`;
export const lblAdd = "Add";
export const lblName = "Name";
export const lblProjectName = "Project";
export const lblEmail = "Email";
export const lblCompany = "Company";
export const lblPortfolio = "Portfolio";
export const lblMobile = "Mobile";
export const lblMessage = "Message";
export const lblPhone = "Phone";
export const lblLastLogin = "Last login";
export const lblAction = "Action";
export const lblLastOnline = "Last online";
export const lblReceivedOn = "Received on";
export const lblMaxSessionCompany = "Max Allowed Session (Company)";
export const lblMaxSessionIndividual = "Max Allowed Session (Individual)";
export const lblActiveSession = "Active Session";
export const lblReferenceNumber = "Reference number";
export const lblBackToSignIn = "Back to sign in";
export const lblStatus = "Status";
export const lblParameters = "Parameters";
export const lblParametersName = "Parameters Name";
export const lblParametersType = "Parameters Type";
export const lblPreviousPage = "Previous page";
export const lblNextPage = "Next page";
export const lblPassword = "Password";
export const lblConfirmPassword = "Confirm password";
export const lblNewUser = "New user";
export const lblPersona = "Persona";
export const lblEditUser = "Edit user";
export const lblAsteriskRequired = "* Required";
export const lblSave = "Save";
export const lblRestore = "Restore";
export const lblWarning = "Warning";
export const lblNotConnected = "Offline";
export const lblDownload = "Download";
export const lblDownloadData = "Station Data Download ";
export const lblErrorReports = "Error Reports";
export const lblErrorReportsTable = "Station Error Reports Table";
export const lblForgetPassword = "Forget password";
export const lblFrom = "From";
export const lblTo = "To";
export const lblOk = "OK";
export const lblSubmit = "Submit";
export const lblInformation = "Information";
export const lblArchive = "Archive";
export const lblRestoring = "Restoring...";
export const lblActivating = "Activating...";
export const lblActivate = "Activate";
export const lblSaving = "Saving...";
export const lblArchiving = "Archiving...";
export const lblDeactivating = "Deactivating...";
export const lblDeleting = "Deleting...";
export const lblDeactivate = "Deactivate";
export const lblBack = "Back";
export const lblSignInWithYourEmailAndPassword = "Sign in with your email and password";
export const lblEnterEmail = "Enter your log in email";
export const lblEnterNewPassword2Reset = "Enter your new password to reset";
export const lblSignIn = "Sign in";
export const lblRole = "Role";
export const lblSend = "Send";
export const lblNewStation = "New station";
export const lblEditStation = "Edit station";
export const lblStationId = "Station Id";
export const lblDescription = "Description";
export const lblLocation = "Location";
export const lblCountry = "Country";
export const lblCity = "City";
export const lblLongitude = "Longitude";
export const lblLatitude = "Latitude";
export const lblStation = "Station";
export const lblDevice = "Device";
export const lblStationInformation = `${lblStation} information`;
export const lblStationConfig = "Station config";
export const lblStationsHealth = "Stations Health";
export const lblStationsHealthTable = "Stations Health Status Table";
export const lblTotal = "Total";
export const lblTotalRemoteStation = "Total Remote Stations";
export const lblNewStationConfig = "New station config";
export const lblEditStationConfig = "Edit station config";
export const lblDataConfigs = "Device data configs";
export const lblHealthConfigs = "Health data configs";
export const lblHealthy = "Online";
export const lblIndex = "Index";
export const lblDataType = "Data type";
export const lblDelete = "Delete";
export const lblDisable = "Disable";
export const lblClose = "Close";
export const lblCloseReport = `${lblClose} this error report`;
export const lblReopenReport = `Re-open this error report`;
export const lblSelectStations = "Select stations";
export const lblSelectRealTimeFiles = "Real Time Fileds";
export const lblSelectStationConfig = "Select station config";
export const lblSelectStation = "Select station";
export const lblSelect = "Select";
export const lblRange = "Range";
export const lblWindSpeed = "Wind speed";
export const lblWindDirection = "Wind direction";
export const lblPyranometer = "Pyranometer";
export const lblIrradiance = "Irradiance";
export const lblHumidity = "Humidity";
export const lblAmbientTemperature = "Ambient temperature";
export const lblModuleTemperature = "Module temperature";
export const lblIrradianceTemperature = "Irradiance temperature";
export const lblActivePower = "Active power";
export const lblHistoryRecords = "Historical Records";
export const lblHistoricalRecordsChart = "Station Historical Records Chart";
export const lblHistoryRecordsDisclaimer = "Disclaimer: The default method for aggregation is average of the selected period.";
export const lblStationRealtimeData = "Station Realtime Data";
export const lblStationRealtimeChart = "Station Info and Realtime Data Chart";
export const lblStatistics = "Station Statistics";
export const lblStatisticsCharts = "Station Statistics Info and Charts";
export const lblStatisticsDisclaimer = "Disclaimer: The above values provides general information about insolation and an overview of PV system status and is estimated on a best-effort basis. The total generated energy value may differ from the reading of the energy meter(s).";
export const lblPortfolioStatisticsDisclaimer = "The above values provides portfolio performance across levels (Company, Country, City, Project) within a company. System capacity, energy yields, and performance ratios are estimated on a best-effort basis and may vary due to site conditions, measurement differences, and data aggregation methods.";
export const lblWeatherInfo = "Weather Information";
export const lblEnergyMeterChart = "Real-time Energy Meter Chart";
export const lblInverterChart = "Real-time Inverter Meter Chart";
export const lblDay = "Day";
export const lblMonth = "Month";
export const lblYear = "Year";
export const lblDisplayMode = "Display Mode";
export const lblFieldName = "Field name";
export const lblDownloadLink = "Download link";
export const lblDownloadDataList = "Download Data List";
export const lblFileSize = "File Size";
export const lblLastModified = "Last Modified";
export const lblSelectedFileList = "Selected File List";
export const lblAggMethod = "Aggregation method";
export const lblAgg = "Aggregation";
export const lblSlowDataGraphReference = "History graph reference";
export const lblReferenceForSlowData = "Referance for Slow Data";
export const lblReferenceForCapacityData = "Referance for Capacity Data";
export const lblReferenceForFastData = "Referance for Fast Data";
export const lblSelectCustomDownloadFields = "Select Custom Fields";
export const lblCustomDownloadFields = "Custom Fields";
export const lblForecasting = "Forecasting";
export const lblForecastingDataChart = "Forecasting Data Chart";
export const lblForecastingRange = "Range";
export const lblForecastingResolution = "Resolution";
export const lblSmartOM = "SMART O&M";
export const lblSystemFault = "Fault Overview";
export const lblFaultOverview = "Fault Overview (Beta)";
export const lblSmartOMPerformance = "PV System Performance";
export const lblSmartOMDetection = "Fault Detection Details";
export const lblPortfolioFaultTitle = "Fault Detection Details";
export const lblSmartOMHistogram = "Fault Histogram";
export const lblSmartOMLog = "Maintenance Log";

export const placeholderEnterName = "Enter name";
export const placeholderSearch = "Search";
export const placeholderTypeRefNoOrStationId = "Enter station id";
export const plaecholderTypeStationName = "Enter station name";

export const msgIdRequired = "Unique Id is required";
export const msgNameRequired = "Name is required";
export const msgEmailRequired= "Email is required";
export const msgCompanyRequired= "Company is required";
export const msgMaxSessionCompanyRequired= "Max session (Company) is required";
export const msgMaxSessionClientRequired= "Max session (Individual) is required";
export const msgPasswordRequired = "Password is required";
export const msgPasswordsDoNotMatch = "Passwords do not match";
export const msgConfirmPasswordRequired = "Confirm password is required";
export const msgMobileRequired = "Mobile is required";
export const msgSavedSuccessfully = "Saved successfully!";
export const msgMessageIsSent = "Message is sent.";
export const msgSaveFailed = "Save failed!";
export const msgActivatedSuccessfully = "Activated successfully!";
export const msgDownloadReady = "Download ready!";
export const msgNotifyDownloadReady = "A notification email will be sent to you when the data is ready for download.";
export const msgActivationFailed = "Activation failed!";
export const msgRestoringFailed = "Restoring failed!";
export const msgRestoredSuccessfully = "Restored successfully!";
export const msgDeactivatedSuccessfully = "Deactivated successfully!";
export const msgArchivedSuccessfully = "Acrhived successfully!";
export const msgDeletedSuccessfully = "Deleted successfully!";
export const msgDeactivationFailed = "Deactivation failed!";
export const msgArchivingFailed = "Archiving failed!";
export const msgDeletingFailed = "Deleting failed!";
export const msgStationCongBeingUsed = "Cannit delete! Station config is being used.";
export const msgUniqueFieldName = "Field names in configuration must be unique";
export const msgDeleteConfirm = "Are you sure to delete?";
export const msgDeactivateConfirm = "Are you sure to deactivate?";
export const msgDisabledConfirm = "Are you sure to archive?";
export const msgNoUserIsCreated = "No user is created at this moments.";
export const msgNoStationIsCreated = "No station is created at this moments.";
export const msgNoStationIsSelected = "No station is selected at this moments.";
export const msgNoCustomFields = "No custom fields are selected";
export const msgIncorrectCredential = "Please check your username & password!";
export const msgMaxSessionLogin = "Over max session, you cannot login. If  you accidentally close your browser, please log in 15 mins later.";
export const msgUnknownErrorOccured = "Unknow error occured!";
export const msgLoginError = "Please check your username and password and try again.";
export const msgStationNameAlreadyExisted = "Station name already exists. User another one.";
export const msgUserAlreadyExists = "User already exists with this email";
export const msgCannotAddExistingField = "Cannot add existing field again.";
export const msgResetPassworLinkSent = "We've sent a password reset link to your email.";
export const msgPasswordIsReset = "Password is reset";
export const msgInvalidEmail = "Invalid email!";
export const msgErrorReportIsClosed = "Error report is closed.";

export const colorPrimary = "primary";
export const colorSecondary = "secondary";

export const btnRaised = "contained";

export const txtNormal = "normal";
export const txtOutlined = "outlined";

export const lblStartDate = "Start Date";
export const lblEndDate = "End Date";

export const idSelectRole = "selectRole";
export const idSelectFieldName = "selectFieldName";
export const idSelectPersona = "selectPersona"
export const idMapStations = "mapStations";
export const idIPAGraph = "ipaGraph"
export const idSelectStation = "selectStation";
export const idSelectDevice = "selectDevice";
export const idSelectRange = "selectRange";
export const idRealTimeFields = "realtimefields";
export const idSelectDay = "selectDay";
export const idSelectMonth = "selectMonth";
export const idSelectYear = "selectYear";
export const idSelectAgg = "selectAgg";
export const idSelectStatus = "selectStatus";
export const idMapSearchBox = "mapSearchBox";
export const idRefSlowData = "refSlowData";
export const idRefCapacityData = "refCapacityData";
export const idRefFastData = "refFastData";

export const chartTimeFormat = "HH:mm:ss";
export const dateFormat = "dd MMM, yyyy";
export const timeFormat = "hh:mm a";
export const dateTimeFormat = `${dateFormat} ${timeFormat}`;
export const dateTimeFormat2 = "dd/MM/yyyy HH:mm:ss";

export const camelize = str => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).replace(/\s+/g, '');
}

const upperCase = str => str.toUpperCase();

const unCamelCase = str => {
  str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
  str = str.toLowerCase(); //add space between camelCase text
  return str;
}

// Replace first char of each sentence (new line or after '.\s+') to
// UPPERCASE
export const sentenceCase = str => unCamelCase(str).replace(/(^\w)|\.\s+(\w)/gm, upperCase);